export default __webpack_public_path__ + "assets/images/982c131b3c85fb396a20ec2ad0fb0cfa.png";